import socketIOClient from 'socket.io-client';

// eslint-disable-next-line import/prefer-default-export
export const getSocketClient = (username) =>
 socketIOClient(`${process.env.REACT_APP_SOCKET}?username=${username}`, {
 transports: ['websocket'],
 path: '/api/socket.io'
 });